<template>
  <div class="e-claim" v-if="compony && jd">
    <p class="top-nav w">
      <router-link to="/">首页</router-link> / <router-link :to="`/compony/${this.$route.params.id}`">公司信息</router-link> / <span>职位描述</span>
    </p>
    <div class="e-top">
      <div class="w">
        <p class="top-m-nav" @click="$router.go(-1)">
          <i class="iconfont icon-zuojiantou"></i>
          职位描述
        </p>
        <p class="title">
          {{ jd.name }}<span>{{ jd.salary }}</span>
        </p>
        <p class="desc">
          {{ jd.city || compony.city }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ jd.edu || '无需求' }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ jd.type }}
        </p>
        <ul class="tags">
          <li v-for="(tag, tagIndex) in compony.tags" :key="tagIndex">{{ tag }}</li>
        </ul>
        <a v-if="compony.enroll" class="btn" target="_blank" :href="compony.enroll">投递简历</a>
        <a v-else class="btn" target="_blank" href="http://cairdc2020.mikecrm.com/g49WWzO">立即沟通</a>
      </div>
    </div>
    <ul class="e-tags w">
      <li v-for="(tag, tagIndex) in compony.tags" :key="tagIndex">{{ tag }}</li>
    </ul>
    <div class="e-body w">
      <div class="info">
        <p class="title">
          职位描述
        </p>
        <p class="content">{{ jd.content.replace(/ {2,}/g, '') }}</p>
      </div>
      <compony-info/>
    </div>
  </div>
</template>

<script>
import componys from '@/data.js'
import componyInfo from '@/views/components/ComponyInfo';
import vxShare from '@/util/vxShare.js'

export default {
  components: {
    componyInfo
  },
  data () {
    return {
      compony: null,
      jd: null
    }
  },
  metaInfo () {
    return {
      title: this.jd.name + '_睿慕课'
    }
  },
  mounted () {
    vxShare()
  },
  created () {
    this.compony = componys[this.$route.params.id]
    this.jd = componys[this.$route.params.id].jds[this.$route.params.jid]
  }
}
</script>

<style lang="scss" scoped>
.e-claim{
  position: relative;
  .e-top{
    width: 100%;
    height: 200px;
    background: url(../../static/inner-bg.jpg);
    background-size: cover;
    background-position: bottom center;
    box-sizing: border-box;
    .w{
      position: relative;
      height: 100%;
      .top-m-nav{
        display: none;
      }
      .title{
        padding-top: 60px;
        margin-bottom: 6px;
        font-size: 32px;
        line-height: 42px;
        color: white;
        span{
          color: #FF8330;
          font-weight: 700;
          display: inline-block;
          margin-left: 30px;
        }
      }
      .desc{
        font-size: 14px;
        line-height: 18px;
        opacity: 0.75;
        color: #fff;
      }
      .tags{
        padding-top: 20px;
        display: flex;
        box-sizing: border-box;
        flex-wrap: wrap;
        opacity: .75;
        li{
          font-size: 13px;
          border: 1px solid #fff;
          padding: 0 13px;
          line-height: 26px;
          box-sizing: border-box;
          color: #fff;
          margin-right: 10px;
          border-radius: 40px;
        }
      }
      .btn{
        width: 180px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        color: #FFFFFF;
        background-color: #5730f1;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        text-decoration: none;
        font-size: 15px;
      }
    }
  }
  .e-body{
    padding-bottom: 20px;
    margin-top: 70px;
    display: flex;
    justify-content: space-between;
    .info{
      width: 820px;
      .title{
        font-size: 16px;
        line-height: 20px;
        padding-bottom: 12px;
        border-bottom: 1px solid #F1F1F1;
        font-weight: 700;
      }
      .content{
        white-space: pre-wrap;
        margin-bottom: 32px;
        margin-top: 32px;
        font-size: 14px;
        line-height: 32px;
        color: #313131;
      }
    }
  }
  .e-tags{
    display: none;
  }
}

@media (max-width: 768px){
  .e-claim{
    .e-top{
      width: 100%;
      height: auto;
      padding-bottom: 26px;
      background: url(../../static/bg_info.png);
      background-size: cover;
      box-sizing: border-box;
      .w{
        position: relative;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .top-m-nav{
          display: block;
          position: absolute;
          color: #fff;
          opacity: .75;
          font-size: 14px;
          left: 20px;
          top: 23px;
          text-decoration: none;
        }
        .title{
          padding-top: 60px;
          margin-bottom: 10px;
          font-size: 20px;
          line-height: 25px;
          color: white;
          span{
            color: #FF8330;
            font-weight: 700;
            display: inline-block;
            margin-left: 12px;
          }
        }
        .desc{
          font-size: 13px;
          line-height: 16px;
          opacity: 0.75;
          color: #fff;
        }
        .tags{
          display: none;
        }
        .btn{
          width: 110px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #FFFFFF;
          background-color: #3387F1;
          text-decoration: none;
          font-size: 14px;
          border-radius: 30px;
          transform: translate(0);
          position: static;
          display: block;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin-top: 22px;
        }
      }
    }
    .e-body{
      margin-top: 15px;
      display: block;
      padding-bottom: 60px;
      .info{
        width: 100%;
        border-top: 8px solid #F1F1F1;
        box-sizing: border-box;
        padding: 0 20px;
        padding-top: 20px;
        .title{
          font-size: 16px;
          line-height: 20px;
          padding-bottom: 12px;
          border-bottom: 1px solid #F1F1F1;
          font-weight: 700;
        }
        .content{
          white-space: pre-wrap;
          margin-bottom: 26px;
          margin-top: 26px;
          font-size: 14px;
          line-height: 26px;
          color: #313131;
        }
      }
    }
    .e-tags{
      display: block;
      padding: 0 15px;
      padding-top: 15px;
      display: flex;
      box-sizing: border-box;
      flex-wrap: wrap;
      li{
        border: none;
        background-color: rgba($color: #3387F1, $alpha: .05);
        padding: 0 13px;
        line-height: 21px;
        box-sizing: border-box;
        color: #5730f1;
        margin-right: 8px;
        margin-bottom: 8px;
        border-radius: 40px;
        font-size: 12px;
      }
    }
  }
}
</style>
